// NSAUTDTO — el circuito de claves de descuento, replicado del PRG de Clipper
// (.claude/docs/PRUEBA.PRG). Lo comparten descuento y descuento gerencial:
// es la misma aritmética con distintas semillas.
//
// Tres pasos, de los cuales la app hace solo el 2:
//   1. En la sucursal, el Clipper genera un código de 4 dígitos a partir de la
//      sucursal y el nro de pedido: "ruido" (2 dígitos, sale del pedido) +
//      "dígito verificador" (2 dígitos, ata el ruido a la sucursal).
//   2. Acá: se valida que el código pertenezca a la sucursal elegida (no se
//      conoce el pedido, pero el verificador se recalcula con el ruido) y se
//      genera el código final, también de 4 dígitos.
//   3. En la sucursal, el Clipper rehace el paso 2 y compara con el final.
//
// No interviene la fecha: el código final vale hasta que se use.
//
// Este archivo es aritmética pura y no importa nada, para poder testearlo en
// Node (tests/nsautdto.test.mjs) y contrastarlo con lo que muestra PRUEBA.PRG.

// Semillas "que solo conocen los programas". DIOS es el gerencial.
const SEMILLAS = {
  gerencial: { s1: 8421, s2: 9973, s3: 17389, s4: 4127 },
  sucursal: { s1: 7919, s2: 8191, s3: 13577, s4: 5023 },
};

const semillas = (gerencial) => (gerencial ? SEMILLAS.gerencial : SEMILLAS.sucursal);

const parametrosValidos = (suc, codigo) =>
  Number.isInteger(suc) && suc > 0 && suc <= 9999 &&
  Number.isInteger(codigo) && codigo > 0 && codigo <= 99999999;

/**
 * Paso 1 (lo hace el Clipper). Está acá para los tests y para probar a mano.
 * Devuelve -1 con parámetros incorrectos.
 */
export function paso1(suc, pedido, gerencial = false) {
  if (!parametrosValidos(suc, pedido)) return -1;
  const { s1, s3 } = semillas(gerencial);

  const ruido = (pedido * s3) % 100;
  const dig = ((suc + ruido) * s1) % 100;
  return ruido * 100 + dig;
}

/**
 * Paso 2 (lo hace la app). Recibe el código del paso 1 y la sucursal; devuelve
 * el código final, o -1 si el código no pertenece a esa sucursal o los
 * parámetros son incorrectos.
 *
 * El Clipper toma el ruido con LEFT(STR(cod,4,0),2) y el verificador con
 * RIGHT(...,2): con los espacios de relleno que pone STR, equivale a dividir
 * por 100 y tomar el resto.
 */
export function paso2(suc, codigo, gerencial = false) {
  if (!parametrosValidos(suc, codigo) || codigo > 9999) return -1;
  const { s1, s2, s4 } = semillas(gerencial);

  const ruido = Math.floor(codigo / 100);
  const dig = codigo % 100;
  if (((suc + ruido) * s1) % 100 !== dig) return -1;

  const ruidoFinal = ((ruido + 13) * s4) % 100;
  return ruidoFinal * 100 + ((suc + ruidoFinal) * s2) % 100;
}

/**
 * Paso 3 (lo hace el Clipper). Devuelve 1 si el código final es el que
 * corresponde a esa sucursal y ese código del paso 1, o -1.
 */
export function paso3(suc, codigo, final, gerencial = false) {
  const esperado = paso2(suc, codigo, gerencial);
  return esperado !== -1 && esperado === final ? 1 : -1;
}
